<template>
    <div>
        <div v-if="loading">Carregando...</div>
        <template v-else>
            <div v-if="notFound">
                <complete :company="company"></complete>
            </div>
            
        </template>
    </div>
    
</template>
<script>
import Complete from './Complete.vue'
export default {
    name: "Check",
    components: {
        Complete
    },
    data(){
        return {
            loading: false,
            notFound: false,
            company: {}
        }
    },
    firestore() {
        this.loading = true
        return {
            ordersTg: this.$db.collection("companies").where("uid", "==", this.$user.uid).get()
            .then((snap) => {
                let companies = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    if(data.uid == this.$user.uid){
                        data.docId = doc.id
                        companies.push(data)
                    }
                });
                if(companies.length > 0)
                    this.$router.replace('app')
                
                else
                    this.notFound = true
                this.loading = false
            })
            }
    },
}
</script>